// 物理工厂
<template>
  <div class="admin">
    <div class="submit"><el-button type="primary"  @click="submitForm">保存</el-button><span class="tip">操作后务必保存，以免数据丢失</span></div>
    <el-form :model="jsonData" ref="jsonData" label-width="80px">
      <div v-show="$parent.subMenuId===1" name="工厂总览">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="园区总览" name="first">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="园区总览" label-width="100px">
                  <MzInput v-model.trim="jsonData.subpage.yqzl" type="textarea" :rows="10" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="当月生产量" name="second">
            <el-row :gutter="10" v-if="jsonData.subpage">
              <el-col :span="2" class="label">
                <el-form-item label="单位" label-width="40px">
                  <MzInput v-model.trim="jsonData.subpage.dyscl.unit" placeholder="请输入"></MzInput>
                </el-form-item>
                <el-button type="primary" size="small" @click="rightData2('sub_dyscl',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.subpage">
                <div v-for="(item,index) in jsonData.subpage.dyscl.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('sub_dyscl',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('sub_dyscl',1,'add')">添加X轴类别</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('sub_dyscl',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="X轴" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('sub_dyscl',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="年生产计划" name="third">
            <el-row :gutter="10" v-if="jsonData.subpage">
              <el-col :span="2" class="label">
                <el-form-item label="单位" label-width="40px">
                  <MzInput v-model.trim="jsonData.subpage.nscjh.unit" placeholder="请输入"></MzInput>
                </el-form-item>
                <el-button type="primary" size="small" @click="rightData2('sub_nscjh',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.subpage">
                <div v-for="(item,index) in jsonData.subpage.nscjh.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('sub_nscjh',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('sub_nscjh',1,'add')">添加X轴类别</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('sub_nscjh',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="X轴" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('sub_nscjh',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="年销售计划" name="four">
            <el-row :gutter="10" v-if="jsonData.subpage">
              <el-col :span="2" class="label">
                <el-form-item label="单位" label-width="40px">
                  <MzInput v-model.trim="jsonData.subpage.nxsjh.unit" placeholder="请输入"></MzInput>
                </el-form-item>
                <el-button type="primary" size="small" @click="rightData2('sub_nxsjh',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.subpage">
                <div v-for="(item,index) in jsonData.subpage.nxsjh.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('sub_nxsjh',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('sub_nxsjh',1,'add')">添加X轴类别</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('sub_nxsjh',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="X轴" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('sub_nxsjh',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="监控视频" name="five">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="监控视频链接" label-width="100px">
                  <MzInput v-model.trim="jsonData.subpage.jksp" placeholder="视频格式mp4"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===2" name="科技小院">
        <el-tabs v-model="tabActive" v-if="jsonData.detail">
          <el-tab-pane label="小院介绍" name="first">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="小院介绍" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.kjxy.xyjs" type="textarea" :rows="10" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="专家信息" name="second">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>专家信息</p>
                <el-button type="primary" size="small" @click="updateData('zjxx','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <el-col :span="8" v-for="(item,index) in jsonData.detail.kjxy.zjxx" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('zjxx','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="姓名" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="照片" label-width="40px">
                      <mzfile v-model="item.photo" tip="只能上传jpg/jpeg/png文件，比例5:6"></mzfile>
                    </el-form-item>
                    <el-form-item label="介绍" label-width="40px">
                      <MzInput v-model.trim="item.info" type="textarea" :rows="6" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="证书" name="third">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>证书</p>
                <el-button type="primary" size="small" @click="updateData('zs','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <el-col :span="8" v-for="(item,index) in jsonData.detail.kjxy.zs" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('zs','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="证书图片" label-width="80px">
                      <mzfile v-model="item.url" tip="只能上传jpg/jpeg/png文件"></mzfile>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="背景图" name="four">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="背景图" label-width="60px">
                  <mzfile v-model="jsonData.detail.kjxy.bg" tip="只能上传jpg/jpeg/png文件，比例16:9"></mzfile>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane :label="item.name" :name="item.type" v-for="item in jsonData.detail.kjxy.kjs" :key="item.type">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="引导视频开关" label-width="120px">
                  <el-switch
                    v-model="item.videoSwitch"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-for="(it,i) in item.video" :key="i">
                <el-form-item :label="i<3?'监控视频链接左'+(i+1):'监控视频链接右'+(i-2)" label-width="120px">
                  <MzInput v-model.trim="it.url" placeholder="视频格式mp4"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
            <el-card class="box-card" v-for="it in item.tree" :key="it.id">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="标题" label-width="120px">
                    <MzInput v-model.trim="it.title" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="项目密级" label-width="80px">
                    <MzInput v-model.number="it.star" placeholder="0-5颗星"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="立项简介" label-width="120px">
                    <MzInput v-model.trim="it.intro" type="textarea" :rows="3" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="项目背景与意义" label-width="120px">
                    <MzInput v-model.trim="it.bj" type="textarea" :rows="3" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="项目目标" label-width="120px">
                    <MzInput v-model.trim="it.mb" type="textarea" :rows="3" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="项目进展" label-width="120px">
                    <MzInput v-model.trim="it.jz" type="textarea" :rows="3" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="项目成果" label-width="120px">
                    <MzInput v-model.trim="it.cg" type="textarea" :rows="3" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="项目相关视频" label-width="120px">
                    <el-col :span="6" v-for="(video,index) in it.sp" :key="index">
                      <el-card class="box-card">
                        <span class="del" @click="updateData('xgsp','del',index,it)"><i class="el-icon-circle-close"></i></span>
                          <video :src="video.videoUrl" controls class="video">
                            Your browser does not support the video tag.
                          </video>
                      </el-card>
                    </el-col>
                    <mzfile2 name="上传视频" type="video" @success="url => handleUploadSuccess(it, url)"></mzfile2>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===3" name="二号工厂">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="订单信息" name="first">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>订单信息</p>
                <el-button type="primary" size="small" @click="updateData('two_ddxx','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <div v-for="(item,index) in jsonData.detail.two.ddxx" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('two_ddxx','del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <el-form-item label="产品名称" label-width="80px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="下单时间" label-width="80px">
                          <MzInput v-model.trim="item.time" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="订单编号" label-width="80px">
                          <MzInput v-model.trim="item.code" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="订单金额" label-width="80px">
                          <MzInput v-model.trim="item.price" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="订单状态" label-width="80px">
                          <MzInput v-model.trim="item.status" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="原料数据" name="second">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-col :span="3">
                  <el-form-item label="最大值" label-width="60px">
                    <MzInput v-model.number="jsonData.detail.two.ylsj.max" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="单位" label-width="60px">
                    <MzInput v-model.trim="jsonData.detail.two.ylsj.unit" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="updateData('two_ylsj','add')">添加</el-button>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.two.ylsj.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('two_ylsj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="名称" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="库存数据" name="third">
            <el-row :gutter="10">
              <el-col :span="2" class="label">
                <p>库存数据</p>
                <el-button type="primary" size="small" @click="rightData2('two_kcsj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.detail">
                <div v-for="(item,index) in jsonData.detail.two.kcsj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('two_kcsj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('two_kcsj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('two_kcsj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('two_kcsj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="产量数据" name="four">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-col :span="3">
                  <el-form-item label="最大值" label-width="60px">
                    <MzInput v-model.number="jsonData.detail.two.clsj.max" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="单位" label-width="60px">
                    <MzInput v-model.trim="jsonData.detail.two.clsj.unit" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="updateData('two_clsj','add')">添加</el-button>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.two.clsj.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('two_clsj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="名称" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="销售数据" name="five">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-col :span="3">
                  <el-form-item label="最大值" label-width="60px">
                    <MzInput v-model.number="jsonData.detail.two.xssj.max" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="单位" label-width="60px">
                    <MzInput v-model.trim="jsonData.detail.two.xssj.unit" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="updateData('two_xssj','add')">添加</el-button>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.two.xssj.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('two_xssj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="名称" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="背景图" name="six">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="背景图类型" label-width="100px">
                  <el-radio-group v-model="jsonData.detail.two.bgType">
                    <el-radio :label="1">720云链接</el-radio>
                    <el-radio :label="2">图片</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="jsonData.detail.two.bgType===1">
                <el-form-item label="720云链接" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.two.bg720" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="jsonData.detail.two.bgType===2">
                <el-form-item label="图片" label-width="100px">
                  <mzfile v-model="jsonData.detail.two.bgImg" tip="只能上传jpg/jpeg/png文件，比例16:9"></mzfile>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===4" name="一号工厂">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="订单信息" name="first">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>订单信息</p>
                <el-button type="primary" size="small" @click="updateData('one_ddxx','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <div v-for="(item,index) in jsonData.detail.one.ddxx" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('one_ddxx','del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <el-form-item label="产品名称" label-width="80px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="下单时间" label-width="80px">
                          <MzInput v-model.trim="item.time" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="订单编号" label-width="80px">
                          <MzInput v-model.trim="item.code" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="订单金额" label-width="80px">
                          <MzInput v-model.trim="item.price" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="订单状态" label-width="80px">
                          <MzInput v-model.trim="item.status" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="原料数据" name="second">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-col :span="3">
                  <el-form-item label="最大值" label-width="60px">
                    <MzInput v-model.number="jsonData.detail.one.ylsj.max" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="单位" label-width="60px">
                    <MzInput v-model.trim="jsonData.detail.one.ylsj.unit" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="updateData('one_ylsj','add')">添加</el-button>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.one.ylsj.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('one_ylsj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="名称" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="库存数据" name="third">
            <el-row :gutter="10">
              <el-col :span="2" class="label">
                <p>库存数据</p>
                <el-button type="primary" size="small" @click="rightData2('one_kcsj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.detail">
                <div v-for="(item,index) in jsonData.detail.one.kcsj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('one_kcsj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('one_kcsj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('one_kcsj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('one_kcsj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="产量数据" name="four">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-col :span="3">
                  <el-form-item label="最大值" label-width="60px">
                    <MzInput v-model.number="jsonData.detail.one.clsj.max" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="单位" label-width="60px">
                    <MzInput v-model.trim="jsonData.detail.one.clsj.unit" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="updateData('one_clsj','add')">添加</el-button>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.one.clsj.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('one_clsj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="名称" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="销售数据" name="five">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-col :span="3">
                  <el-form-item label="最大值" label-width="60px">
                    <MzInput v-model.number="jsonData.detail.one.xssj.max" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="单位" label-width="60px">
                    <MzInput v-model.trim="jsonData.detail.one.xssj.unit" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" size="small" @click="updateData('one_xssj','add')">添加</el-button>
                </el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.one.xssj.data" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('one_xssj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="名称" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="背景图" name="six">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="背景图" label-width="60px">
                  <mzfile v-model="jsonData.detail.one.bg" tip="只能上传jpg/jpeg/png文件，比例16:9"></mzfile>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===5" name="动力车间">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="车间介绍" name="first">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="车间介绍" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.dlcj.cjjs" type="textarea" :rows="10" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="能耗统计" name="second">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>能耗类型</p>
                <el-button type="primary" size="small" @click="rightData2('dlcj_nhtj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.detail">
                <div v-for="(item,index) in jsonData.detail.dlcj.nhtj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('dlcj_nhtj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('dlcj_nhtj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('dlcj_nhtj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('dlcj_nhtj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="设备运行情况" name="third">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="4" v-for="(item,index) in jsonData.detail.dlcj.sbyxqk" :key="index">
                <el-form-item :label="item.name" label-width="60px">
                  <MzInput v-model.trim="item.value" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="环境监测" name="six">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="4" v-for="(item,index) in jsonData.detail.dlcj.hjjc" :key="index">
                <el-card class="box-card">
                <el-form-item label="名称" label-width="40px">
                  <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                </el-form-item>
                <el-form-item label="值" label-width="40px">
                  <MzInput v-model.trim="item.value" placeholder="请输入"></MzInput>
                </el-form-item>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="监控视频" name="four">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="监控视频链接" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.dlcj.jksp" placeholder="视频格式mp4"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="背景图" name="five">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="背景图" label-width="60px">
                  <mzfile v-model="jsonData.detail.dlcj.bg" tip="只能上传jpg/jpeg/png文件，比例16:9"></mzfile>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===6" name="数字赋能中心">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="赋能中心介绍" name="first">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="赋能中心介绍" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.szzx.fnzxjs" type="textarea" :rows="10" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="能耗统计" name="second">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>能耗类型</p>
                <el-button type="primary" size="small" @click="rightData2('szzx_nhtj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.detail">
                <div v-for="(item,index) in jsonData.detail.szzx.nhtj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('szzx_nhtj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('szzx_nhtj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('szzx_nhtj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('szzx_nhtj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="接待数据" name="third">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>接待数据</p>
                <el-button type="primary" size="small" @click="updateData('jdsj','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <el-col :span="3" v-for="(item,index) in jsonData.detail.szzx.jdsj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('jdsj','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="X轴" label-width="40px">
                      <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="值" label-width="40px">
                      <MzInput v-model.number="item.value" placeholder="请输入" style="width:80%"></MzInput>人
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="参观接待" name="four">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="2" class="label">
                <p>参观接待图片</p>
                <el-button type="primary" size="small" @click="updateData('cgjd','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <el-col :span="8" v-for="(item,index) in jsonData.detail.szzx.cgjd" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('cgjd','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="图片" label-width="40px">
                      <mzfile v-model="item.url" tip="只能上传jpg/jpeg/png文件"></mzfile>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="监控视频" name="five">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="监控视频链接" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.szzx.jksp" placeholder="视频格式mp4"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="背景图" name="six">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="24">
                <el-form-item label="背景图" label-width="60px">
                  <mzfile v-model="jsonData.detail.szzx.bg" tip="只能上传jpg/jpeg/png文件，比例16:9"></mzfile>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-form>
  </div>
</template>

<script>

import axios from "axios"
import mzfile from '@/components/mz_upload/index';
import mzfile2 from '@/components/mz_upload/fileUpload';
export default {
  components: {mzfile,mzfile2},
  name: '',
  data() {
    return {
      activeNames: [],
      tabActive: 'first',
      fileHandle: null,
      jsonData: {subpage:'',detail:'',info:''},
    };
  },
  created() {
    // this.jsonData = {
    //   subpage:{
    //     jksp: '',
    //     yqzl: '该产业园是炉霍县畜牧业精深加工重点企业、甘孜州国家级牦牛特色产业集群核心项目，位于炉霍县新都镇（海拔 3200 米）。\n现有年产 3000 吨食用酪蛋白生产线、检测实验室，正建牦牛酪蛋白产学研用中心，与西南民族大学药学与食品学院合作；以高原牦牛奶渣为原料，产品应用于食品、医药等领域，销往多省及韩国（2022 年实现四川酪蛋白首次出口），长期合作企业 22 家（含 1 家上市企业）。\n已通过 ISO9001 及乳制品 HACCP 认证，拥有 20 余项专利，是甘孜州农业产业化龙头企业、科技型中小企业，也是四川唯一酪蛋白生产企业。',
    //     dyscl: {
    //       unit: '万盒',
    //       data: [{
    //           "name": "计划生产数量",
    //           "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "实际生产数量",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       }]
    //     },
    //     nscjh: {
    //       unit: '万盒',
    //       data: [{
    //           "name": "计划生产数量",
    //           "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "实际生产数量",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       }]
    //     },
    //     nxsjh: {
    //       unit: '万盒',
    //       data: [{
    //           "name": "计划销售数量",
    //           "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "实际销售数量",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       }]
    //     },
    //   },
    //   detail: {
    //     kjxy: {
    //       bg: '/assets/image/kjxy.jpg',
    //       zs: [{url:'/assets/image/kjxy.jpg'}],
    //       xyjs: '公司重视博士创新站建设，依托现有1000 吨酪蛋白生产线及在建3000吨数字化生产线，与西南民族大学唐善虎教授团队深度合作，已攻关牦牛酪蛋白褐变控制等技术，酪蛋白提取率 90%、纯度达医药级（≥95%），获 20 余项专利。\n创新站设于炉霍酪蛋白精深加工园区，设研发实验室、中试基地等，配先进设备，建项目、资金等管理制度。旨在突破技术瓶颈，推动产品向高附加值转型，建 “产学研用” 体系。进站博士将主导技术研发、产品开发、人才培养及项目申报，助力打造高原乳制品研发转化高地。',
    //       zjxx: [
    //         {
    //           name:'唐善虎',
    //           photo: '/assets/image/zj/1.png',
    //           info: '西南民族大学食品科学与技术学院院长、教授、博士生导师。\n研究方向：2002年博士毕业于美国Arkansas大学食品科学系，一直从事蛋白质食品方面理论和应用研究。 \n主要成果：主持参加国家级和省部级科研项目20余项，获得授权国家发明专利10件、省级成果6项、省部级科技进步二等奖奖3项、三等奖1项，中国奶业协会和国际奶业联盟科学技术发明一等奖1项，发表论文160余篇，国际学术会议交流论文10余篇，主编著作5部。'
    //         },
    //         {
    //           name:'李思宁',
    //           photo: '/assets/image/zj/2.png',
    //           info: '博士，副教授，西南民族大学食品科学与技术学院硕士研究生导师\n研究方向：一直从事食品科学与工程专业的教学与科研工作。\n主要成果：主持国家科技支撑计划项目子课题1项，四川省重点研发计划项目2项、四川省科技成果转化项目1项，中央高校基本科研业务费专项4项；主研国家级、省部级科研项目10余项；获四川省科技进步二等奖1项；在食品科学等国内外期刊发表论文80余篇，其中第一/通讯作者发表论文31篇。副主编著作2部，参编著作1部；参编“十三五”轻工业部规划教材1部；获授权国家发明专利5件、美国发明专利1件。任全国肉禽蛋制品标准化技术委员会畜肉制品分技术委员会委员、四川省食品科学技术学会副秘书长、四川省奶业协会理事。'
    //         },
    //         {
    //           name:'文勇立',
    //           photo: '/assets/image/zj/3.png',
    //           info: '西南民族大学教授，曾任青藏高原研究院副院长。\n担任职务：全国畜牧兽医学会家畜环境卫生学分分会理事，全国牦牛遗传资源保护与利用协会理事，四川畜牧兽医学会养牛学分会副理事长兼秘书长，世界银行扶贫项目四川省专家。\n主要成果：主持国家及省部级科研项目30余项；制订国家行业标准及地方标准5项。获省部级二、三等科技进步奖5项。获授权发明专利及实用新型专利8项。主编参编出版学术著作7部。在国内外刊物发表学术论文100余篇。'
    //         },
    //         {
    //           name:'曹庸',
    //           photo: '/assets/image/zj/4.png',
    //           info: '男，1966年3月出生。博士，教授，博士生导师\n研究方向：食品化学（重点为食品加工过程中物质的生化变化）、功能性食品添加剂与配料、保健食品与大健康产品。\n主要成果：\n1.主持国家科技部、国家自然科学基金和国家林业局等国家级项目共4项；\n2.近5年申报专利48项：已授权19项，29项审批中；获省部级科技进步奖3项；\n3.主持企业横向项目42项，累计科研经费2155万，解决了多项研发和生产中的技术难题，多项技术实现了产业化应用；\n4.近5年培养博士研究生13名（毕业生8名、在读5名），硕士研究生20多名，指导本科毕业生50余名。'
    //         },
    //         {
    //           name:'陈炼红',
    //           photo: '/assets/image/zj/5.png',
    //           info: '教授、硕士生导师，西南民族大学校级学术委员会专家。\n研究方向：青藏高原特色民族食品资源的开发、应用的研究，高原天然产物与功能性食品开发，高原微生物资源开发与利用\n主要成果：先后主持参与国家国家级课题 5 项，省部级课题 4 项；获得四川省科技进步二等奖；以第一作者和通讯作者发表核心及SCI论文 58 篇；主编教材 2 部，参编教材 4 部。'
    //         },
    //         {
    //           name:'江明锋',
    //           photo: '/assets/image/zj/6.png',
    //           info: '男，羌族，博士，博士生导师，西南民族大学教授（三级）。\n研究方向：从事牦牛育种工作及高原畜禽生理基因组、高原生物基因资源的开发与利用；近年来共主持国家自然科学基金等省部级以上项目共15项，参研国家“973”计划前期研究专项等项目15项；获四川省科技进步二等奖2项；国家民委教学成果二等奖1项、在Journal of Dairy Science、BMC Genomics、畜牧兽医学报发表论文近140篇，其中36篇被SCI和EI收录；获得发明专利5项,实用新型专利3项，参编专著3本。'
    //         }
    //       ],
    //       kjs: [{
    //         type: 'yfzx',
    //         name: '成都酪蛋白生物研发中心',
    //         video: [{url:''},{url:''},{url:''},{url:''},{url:''},{url:''}],
    //         tree: [{
    //           id:1,star: 4,title:'牦牛酪蛋白酸钠(钙)研发制备',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:2,star: 4,title:'牦牛酪蛋白磷酸肽、多肽研发制备',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:3,star: 4,title:'牦牛A2-β酪蛋白关键技术研究与高价值生物蛋白产品研发',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:4,star: 4,title:'牦牛乳清蛋白.乳铁蛋白.骨桥蛋白的功能性研究和产品开发',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:5,star: 4,title:'牦牛乳脂CLA提取和营养成分研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:6,star: 4,title:'酪蛋白副产物牦牛乳脂的回收利用研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:7,star: 4,title:'酪蛋白小分子肽在医美 生美产品中的应用研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:8,star: 4,title:'牦牛乳蛋白可降解基材料的技术研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:9,star: 4,title:'酪蛋白小分子肽在医疗保建用品中的应用研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:10,star: 4,title:'可食用蛋白膜的关缝技术研究和产品研发',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         }]
    //       },{
    //         type: 'bscx',
    //         name: '四川省博士创新站',
    //         video: [{url:''},{url:''},{url:''},{url:''},{url:''},{url:''}],
    //         tree: [{
    //           id:1,star: 4,title:'牦牛酪蛋白酸钠(钙)研发制备',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:2,star: 4,title:'牦牛酪蛋白磷酸肽、多肽研发制备',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:3,star: 4,title:'牦牛A2-β酪蛋白关键技术研究与高价值生物蛋白产品研发',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:4,star: 4,title:'牦牛乳清蛋白.乳铁蛋白.骨桥蛋白的功能性研究和产品开发',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:5,star: 4,title:'牦牛乳脂CLA提取和营养成分研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:6,star: 4,title:'酪蛋白副产物牦牛乳脂的回收利用研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:7,star: 4,title:'酪蛋白小分子肽在医美 生美产品中的应用研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:8,star: 4,title:'牦牛乳蛋白可降解基材料的技术研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:9,star: 4,title:'酪蛋白小分子肽在医疗保建用品中的应用研究',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         },{
    //           id:10,star: 4,title:'可食用蛋白膜的关缝技术研究和产品研发',intro:'立项时间:XX年XX月\n立项负责人:郑亮\n项目专家:XXX',bj:'A2型-酪蛋白因其更亲和人体的特性，被证实可减少饮用普通牛奶(含A1蛋白)后产生的不适反应，全球范围内A2蛋白乳制品市场快速增长，已成为高端乳制品的重要细分领域。高原牦牛乳作为特色资源，其酪蛋白组成与普通荷斯坦奶牛存在差异，牦牛乳酪蛋白天然富含A2型-酪蛋白，具备开发天然A2型牦牛奶酪蛋白产品的巨大潜力，是形成产品差异化竞争优势的蓝海。本项目是公司从"通用型酪蛋白原料供应商"向"高原特色功能性蛋白成分解决方案提供商"战略转型的关键步骤，能极大提升产品附加信和技术壁垒。本项目瞄准全球高附加信蛋白成分市场，对稀缺的牦牛A2-酪蛋白进行系统性开发。牦牛A2型p-酩蛋白可以凭借"高原"、"纯净"、"稀有"的概念切入高端细分市场，与主流的A2型蛋白形成差异化竞争，市场前景广阔，不仅将为企业创造新的利润增长点，更将引领我国牦牛乳产业向技术尖端化、产品高端化迈进，为民族地区特色资源的可持续高质量发展树立新标杆',mb:'',jz:'',cg:'',sp:[]
    //         }]
    //       }]
    //     },
    //     szzx: {
    //       bg: '/assets/image/szzx.png',
    //       jksp: '',
    //       fnzxjs: '炉霍县建科技赋能产业指挥中心（“数字赋能中心”），探索数字化驱动传统产业升级新路径。其核心是整合全县一二三产业全量数据的 “智慧数据大脑”，覆盖牦牛现代产业园区等七大产业园区，及智慧农业、电商物流等应用场景。\n中心通过智慧农牧业管理、全产业链覆盖、智能巡查、AI 模型识别、数据互通匹配、电商营销赋能、直播带货等方式，为产业与企业赋能，助力产业升级、企业发展及电商销售提升。',
    //       nhtj: [{
    //         "name": "电",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "水",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       },
    //       {
    //           "name": "生物燃料",
    //           "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //       }],
    //       jdsj: [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}],
    //       cgjd: [{url:'/assets/image/jd/jd1.png'},{url:'/assets/image/jd/jd2.png'},{url:'/assets/image/jd/jd3.png'},{url:'/assets/image/jd/jd4.png'},{url:'/assets/image/jd/jd5.png'},{url:'/assets/image/jd/jd6.png'}],
    //     },
    //     one: {
    //       bg: '/assets/image/1.png',
    //       ddxx: [{name: '酪蛋白',time:'2025/09/05',code:'8729023',price:'80000',status:'已完成'}],
    //       ylsj: {unit:'万元',max:6000,data:[{name:'原料1',value:5000},{name:'原料2',value:4000}]},
    //       kcsj: [{
    //         "name": "能耗1",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "能耗2",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       },
    //       {
    //           "name": "能耗3",
    //           "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //       }],
    //       clsj: {unit:'万元',max:6000,data:[{name:'A区',value:5000},{name:'B区',value:4000},{name:'C区',value:3000},{name:'D区',value:4000},{name:'E区',value:2000}]},
    //       xssj: {unit:'%',max:100,data:[{name:'亿元以下',value:80},{name:'0-10亿元',value:60},{name:'10-50亿元',value:40},{name:'50-100亿元',value:20},{name:'100亿元以上',value:10}]},
    //     },
    //     two: {
    //       bg: 'https://www.720yun.com/vr/e3ajtsuvry0',
    //       ddxx: [{name: '酪蛋白',time:'2025/09/05',code:'8729023',price:'80000',status:'已完成'}],
    //       ylsj: {unit:'万元',max:6000,data:[{name:'原料1',value:5000},{name:'原料2',value:4000}]},
    //       kcsj: [{
    //         "name": "能耗1",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "能耗2",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       },
    //       {
    //           "name": "能耗3",
    //           "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //       }],
    //       clsj: {unit:'万元',max:6000,data:[{name:'A区',value:5000},{name:'B区',value:4000},{name:'C区',value:3000},{name:'D区',value:4000},{name:'E区',value:2000}]},
    //       xssj: {unit:'%',max:100,data:[{name:'亿元以下',value:80},{name:'0-10亿元',value:60},{name:'10-50亿元',value:40},{name:'50-100亿元',value:20},{name:'100亿元以上',value:10}]},
    //     },
    //     dlcj: {
    //       bg: '/assets/image/dlcj.png',
    //       jksp: '',
    //       cjjs: '动力车间是酪蛋白数智化工厂的核心能源保障枢纽，为生产全流程供能与配套服务。\n车间配置锅炉、环保处理等关键设备，提供稳定蒸汽、电力等能源，满足酪蛋白生产线及辅助设施运行需求；同步衔接环保系统，确保排放达标。\n其数据接入工厂数字展示中心，实时监控能耗、设备状态，实现能源供应透明化、可控化，为工厂高效、绿色生产筑牢能源根基。',
    //       nhtj: [{
    //         "name": "电",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //       },
    //       {
    //           "name": "水",
    //           "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //       },
    //       {
    //           "name": "生物燃料",
    //           "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //       }],
    //       sbyxqk: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //       hjjc: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //     }
    //   }
    // }
    this.getData('modelWl')
  },
  watch:{
    '$parent.subMenuId':{
      handler(){
        this.tabActive = 'first'
      }
    }
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
        }
      })
    },
    saveData(name){
      let params = {
        fileName: name,
        fileData: this.jsonData
      }
      axios.post(this.$baseUrl+'/api/web/file/data/save',params).then(res => {
        if(res.data.code === 200){
          this.$message({
            message: res.data.msg,
            type: 'success',
            customClass: 'adminMsg'
          });
          this.getData('modelWl')
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error',
            customClass: 'adminMsg'
          });
        }
      })
    },
    updateData(type,btn,index,parent){
      if(btn==='add'){
        if(type==='zjxx'){
          this.jsonData.detail.kjxy.zjxx.push({name:'',photo:'',info:''})
        }else if(type==='jdsj'){
          this.jsonData.detail.szzx.jdsj.push({name:'',value:''})
        }else if(type==='cgjd'){
          this.jsonData.detail.szzx.cgjd.push({url:''})
        }else if(type==='one_ddxx'){
          this.jsonData.detail.one.ddxx.push({name:'',time:'',price:'',code:'',status:''})
        }else if(type==='one_ylsj'){
          this.jsonData.detail.one.ylsj.data.push({name:'',value:''})
        }else if(type==='one_clsj'){
          this.jsonData.detail.one.clsj.data.push({name:'',value:''})
        }else if(type==='one_xssj'){
          this.jsonData.detail.one.xssj.data.push({name:'',value:''})
        }else if(type==='two_ddxx'){
          this.jsonData.detail.two.ddxx.push({name:'',time:'',price:'',code:'',status:''})
        }else if(type==='two_ylsj'){
          this.jsonData.detail.two.ylsj.data.push({name:'',value:''})
        }else if(type==='two_clsj'){
          this.jsonData.detail.two.clsj.data.push({name:'',value:''})
        }else if(type==='two_xssj'){
          this.jsonData.detail.two.xssj.data.push({name:'',value:''})
        }else if(type==='zs'){
          this.jsonData.detail.kjxy.zs.push({url:''})
        }
      }
      if(btn==='del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type==='zjxx'){
            this.jsonData.detail.kjxy.zjxx.splice(index,1)
          }else if(type==='jdsj'){
            this.jsonData.detail.szzx.jdsj.splice(index,1)
          }else if(type==='cgjd'){
            this.jsonData.detail.szzx.cgjd.splice(index,1)
          }else if(type==='one_ddxx'){
            this.jsonData.detail.one.ddxx.splice(index,1)
          }else if(type==='one_ylsj'){
            this.jsonData.detail.one.ylsj.data.splice(index,1)
          }else if(type==='one_clsj'){
            this.jsonData.detail.one.clsj.data.splice(index,1)
          }else if(type==='one_xssj'){
            this.jsonData.detail.one.xssj.data.splice(index,1)
          }else if(type==='two_ddxx'){
            this.jsonData.detail.two.ddxx.splice(index,1)
          }else if(type==='two_ylsj'){
            this.jsonData.detail.two.ylsj.data.splice(index,1)
          }else if(type==='two_clsj'){
            this.jsonData.detail.two.clsj.data.splice(index,1)
          }else if(type==='two_xssj'){
            this.jsonData.detail.two.xssj.data.splice(index,1)
          }else if(type==='xgsp'){
            let item = this.jsonData.detail.kjxy.kjs.find(it => it.type === this.tabActive)
            let it = item.tree.find(it => it.id === parent.id)
            it.sp.splice(index, 1);
          }else if(type==='zs'){
            this.jsonData.detail.kjxy.zs.splice(index,1)
          }
        }).catch(() => {
          console.log("已取消")         
        });
      }
    },
    handleUploadSuccess(item, url) {
      if (url) {
        item.sp.push({ videoUrl: url });
      }
    },
    rightData2(from,type,btn,index){
      if(btn==='add'){
        if(type===0 && from==='sub_dyscl'){
          // 添加类型
          let data = []
          this.jsonData.subpage.dyscl.data[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.subpage.dyscl.data.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='sub_dyscl'){
          // 添加日期
          this.jsonData.subpage.dyscl.data = this.jsonData.subpage.dyscl.data.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='sub_nscjh'){
          // 添加类型
          let data = []
          this.jsonData.subpage.nscjh.data[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.subpage.nscjh.data.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='sub_nscjh'){
          // 添加日期
          this.jsonData.subpage.nscjh.data = this.jsonData.subpage.nscjh.data.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='sub_nxsjh'){
          // 添加类型
          let data = []
          this.jsonData.subpage.nxsjh.data[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.subpage.nxsjh.data.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='sub_nxsjh'){
          // 添加日期
          this.jsonData.subpage.nxsjh.data = this.jsonData.subpage.nxsjh.data.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='szzx_nhtj'){
          // 添加类型
          let data = []
          this.jsonData.detail.szzx.nhtj[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.detail.szzx.nhtj.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='szzx_nhtj'){
          // 添加日期
          this.jsonData.detail.szzx.nhtj = this.jsonData.detail.szzx.nhtj.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='one_kcsj'){
          // 添加类型
          let data = []
          this.jsonData.detail.one.kcsj[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.detail.one.kcsj.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='one_kcsj'){
          // 添加日期
          this.jsonData.detail.one.kcsj = this.jsonData.detail.one.kcsj.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='two_kcsj'){
          // 添加类型
          let data = []
          this.jsonData.detail.two.kcsj[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.detail.two.kcsj.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='two_kcsj'){
          // 添加日期
          this.jsonData.detail.two.kcsj = this.jsonData.detail.two.kcsj.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }
      }
      if(btn==='del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type===0 && from==='sub_dyscl'){
            this.jsonData.subpage.dyscl.data.splice(index,1)
          }else if(type===1 && from==='sub_dyscl'){
            this.jsonData.subpage.dyscl.data = this.jsonData.subpage.dyscl.data.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='sub_nscjh'){
            this.jsonData.subpage.nscjh.data.splice(index,1)
          }else if(type===1 && from==='sub_nscjh'){
            this.jsonData.subpage.nscjh.data = this.jsonData.subpage.nscjh.data.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='sub_nxsjh'){
            this.jsonData.subpage.nxsjh.data.splice(index,1)
          }else if(type===1 && from==='sub_nxsjh'){
            this.jsonData.subpage.nxsjh.data = this.jsonData.subpage.nxsjh.data.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='szzx_nhtj'){
            this.jsonData.detail.szzx.nhtj.splice(index,1)
          }else if(type===1 && from==='szzx_nhtj'){
            this.jsonData.detail.szzx.nhtj = this.jsonData.detail.szzx.nhtj.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='one_kcsj'){
            this.jsonData.detail.one.kcsj.splice(index,1)
          }else if(type===1 && from==='one_kcsj'){
            this.jsonData.detail.one.kcsj = this.jsonData.detail.one.kcsj.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='two_kcsj'){
            this.jsonData.detail.two.kcsj.splice(index,1)
          }else if(type===1 && from==='two_kcsj'){
            this.jsonData.detail.two.kcsj = this.jsonData.detail.two.kcsj.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }
        }).catch(() => {
          console.log("已取消")         
        });
      }
    },
    changeData(type,index,value){
      if(type==='sub_dyscl'){
        this.jsonData.subpage.dyscl.data.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='sub_nscjh'){
        this.jsonData.subpage.nscjh.data.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='sub_nxsjh'){
        this.jsonData.subpage.nxsjh.data.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='szzx_nhtj'){
        this.jsonData.detail.szzx.nhtj.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='one_kcsj'){
        this.jsonData.detail.one.kcsj.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='two_kcsj'){
        this.jsonData.detail.two.kcsj.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }
    },
    submitForm(){
      this.$confirm('此操作将覆盖原有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.initFile()
        this.saveData('modelWl')
      }).catch(() => {
        console.log("已取消")         
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/admin';
</style>